/**
 * RETOBLOCK TERMINAL / CONSOLE OUTPUT DRAWER
 * Ngăn kéo hiển thị thông tin log truyền thông BLE, tiến trình nạp mã và thông báo lỗi runtime.
 */

export class TerminalDrawer {
  constructor(options) {
    this.container = options.container;
    this.onErrorLineClick = options.onErrorLineClick || null;
    this.isCollapsed = false;
    this.currentHeight = 140;

    this.init();
  }

  init() {
    this.container.innerHTML = `
      <div class="terminal-drawer" id="terminal-drawer">
        <div class="terminal-resizer" id="terminal-resizer"></div>
        <div class="terminal-header">
          <div class="terminal-title">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="4 17 10 11 4 5"/><line x1="12" x2="20" y1="19" y2="19"/></svg>
            <span>TERMINAL / CONSOLE LOG</span>
          </div>
          <div class="terminal-controls">
            <button class="btn-terminal-ctrl" id="btn-clear-terminal" title="Xóa toàn bộ log">&times;</button>
            <button class="btn-terminal-ctrl" id="btn-toggle-terminal" title="Thu gọn/Mở rộng">&#9660;</button>
          </div>
        </div>
        <div class="terminal-logs" id="terminal-logs">
          <div class="log-entry info">
            <span class="log-time">[${this.getTimeString()}]</span>
            <span>Hệ thống RETOBLOCK Studio sẵn sàng. Chọn bộ kit RETOCAR-STARTER.</span>
          </div>
        </div>
      </div>
    `;

    this.bindEvents();
  }

  bindEvents() {
    const drawer = document.getElementById('terminal-drawer');
    const resizer = document.getElementById('terminal-resizer');
    const toggleBtn = document.getElementById('btn-toggle-terminal');
    const clearBtn = document.getElementById('btn-clear-terminal');

    // Resizing
    let isResizing = false;
    let startY = 0;
    let startH = 0;

    resizer.addEventListener('mousedown', (e) => {
      isResizing = true;
      startY = e.clientY;
      startH = drawer.offsetHeight;
      document.body.style.cursor = 'ns-resize';
    });

    window.addEventListener('mousemove', (e) => {
      if (isResizing) {
        const delta = startY - e.clientY;
        const newH = Math.max(36, Math.min(400, startH + delta));
        drawer.style.height = `${newH}px`;
        this.currentHeight = newH;
      }
    });

    window.addEventListener('mouseup', () => {
      if (isResizing) {
        isResizing = false;
        document.body.style.cursor = '';
      }
    });

    // Collapse / Expand
    toggleBtn.addEventListener('click', () => {
      this.isCollapsed = !this.isCollapsed;
      if (this.isCollapsed) {
        drawer.style.height = '32px';
        toggleBtn.innerHTML = '&#9650;';
      } else {
        drawer.style.height = `${this.currentHeight}px`;
        toggleBtn.innerHTML = '&#9660;';
      }
    });

    // Clear logs
    clearBtn.addEventListener('click', () => {
      document.getElementById('terminal-logs').innerHTML = '';
    });
  }

  getTimeString() {
    const d = new Date();
    return d.toTimeString().split(' ')[0];
  }

  log(message, type = 'info') {
    const logsEl = document.getElementById('terminal-logs');
    if (!logsEl) return;

    const entry = document.createElement('div');
    entry.className = `log-entry ${type}`;
    entry.innerHTML = `
      <span class="log-time">[${this.getTimeString()}]</span>
      <span>${message}</span>
    `;

    logsEl.appendChild(entry);
    logsEl.scrollTop = logsEl.scrollHeight;

    // Nếu đang thu gọn mà có lỗi thì tự động bung ra
    if (type === 'error' && this.isCollapsed) {
      this.isCollapsed = false;
      const drawer = document.getElementById('terminal-drawer');
      drawer.style.height = `${this.currentHeight}px`;
      document.getElementById('btn-toggle-terminal').innerHTML = '&#9660;';
    }
  }

  logRuntimeError(errorInfo) {
    const logsEl = document.getElementById('terminal-logs');
    if (!logsEl) return;

    const entry = document.createElement('div');
    entry.className = 'log-entry error';
    const hasLine = errorInfo.lineNum && errorInfo.lineNum > 0;
    const clickableClass = hasLine ? ' clickable' : '';
    const titleAttr = hasLine ? ' title="Bấm để nhảy tới dòng lỗi trên Editor"' : '';

    entry.innerHTML = `
      <span class="log-time">[${this.getTimeString()}]</span>
      <span class="error-badge${clickableClass}" data-line="${errorInfo.lineNum}"${titleAttr}>[LỖI DÒNG ${errorInfo.lineNum} - ${errorInfo.errorType}]:</span>
      <span>${errorInfo.message}</span>
    `;

    if (hasLine) {
      const badge = entry.querySelector('.error-badge.clickable');
      if (badge) {
        badge.addEventListener('click', () => {
          if (this.onErrorLineClick) {
            this.onErrorLineClick(errorInfo.lineNum);
          }
        });
      }
    }

    logsEl.appendChild(entry);
    logsEl.scrollTop = logsEl.scrollHeight;

    // Mở bung terminal nếu đang đóng
    const drawer = document.getElementById('terminal-drawer');
    drawer.style.height = `${Math.max(140, this.currentHeight)}px`;
    document.getElementById('btn-toggle-terminal').innerHTML = '&#9660;';
    this.isCollapsed = false;
  }
}
